import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { FocusDiv } from '#/widgets/ui';

import styles from './FavoriteButton.scss';

import FavDefault from '#/static/images/icons/favorite_default.svg';
import FavDefaultBlack from '#/static/images/icons/favorite_default_black.svg';
import FavFelected from '#/static/images/icons/favorite_selected.svg';
import { isWorkstation } from '#/utils/componentStyleConfig';
import { ROLES } from '#/utils/accessibility';

const FavoriteButton = ({
  nav = {},
  isFavorited,
  onClick,
  usePlayerStyle = false,
  favoriteButtonClassName = '',
  containerClassName = '',
}) => {
  let iconToUse = FavFelected;
  if (!isFavorited && usePlayerStyle) {
    iconToUse = FavDefault;
  } else if (!isFavorited && !usePlayerStyle) {
    iconToUse = FavDefaultBlack;
  }

  return (
    <FocusDiv
      className={cx(styles.container, containerClassName)}
      classNameFocused={styles.isFocused}
      onClick={onClick}
      style={
        usePlayerStyle === false
          ? { margin: 'auto 10px', borderColor: 'black' }
          : {}
      }
      nav={nav}
      ariaLabel="Favorite"
      role={ROLES.BUTTON}
    >
      <img
        className={cx(styles.favoriteButton, favoriteButtonClassName)}
        style={
          usePlayerStyle === false && isWorkstation()
            ? { height: '2vw', width: '2vw', padding: '0.3vw' }
            : {}
        }
        src={iconToUse}
        alt="FAV"
        role="presentation"
        aria-hidden="true"
      />
    </FocusDiv>
  );
};

FavoriteButton.propTypes = {
  isFavorited: PropTypes.bool,
  onClick: PropTypes.func,
  usePlayerStyle: PropTypes.bool,
  nav: PropTypes.object,
  favoriteButtonClassName: PropTypes.string,
  containerClassName: PropTypes.string,
};

export default FavoriteButton;
